export default __webpack_public_path__ + "static/media/campton-book.20eb92fd.ttf";